const SAVED_EMAIL_KEY = 'garam-saved-email';

// 로그인 화면에 미리 채울 저장된 이메일을 읽는다. 없거나 읽을 수 없으면 ''.
export function readSavedEmail() {
    try {
        return localStorage.getItem(SAVED_EMAIL_KEY) || '';
    } catch {
        return '';
    }
}

// 로그인에 성공한 이메일을 다음 로그인 때 쓰도록 저장한다.
export function saveEmail(email) {
    try {
        localStorage.setItem(SAVED_EMAIL_KEY, email);
    } catch {
        // 저장할 수 없는 환경(사생활 보호 모드 등)에서는 저장하지 않는다.
    }
}

// 저장된 이메일을 지운다.
export function clearSavedEmail() {
    try {
        localStorage.removeItem(SAVED_EMAIL_KEY);
    } catch {
        // 지울 수 없는 환경에서는 무시한다.
    }
}
